import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { RouteKeys } from 'src/app/share/helper/route-keys.helper';
import { ApiService } from 'src/app/share/services/api.service';
import { AuthService } from 'src/app/share/services/auth.service';
import { PopupService } from 'src/app/share/services/popup.service';
import { UrlService } from 'src/app/share/services/url.service';
import { Geohelper } from '../../helper/geoHelper';
import { ConfigService } from '../../services/config.service';
import { StorageService } from '../../services/storage.service';
import { DragDirection, DragHighlight, Orientation } from 'devextreme/common';

@Component({
    selector: 'app-select',
    templateUrl: './select.component.html',
    styleUrls: ['./select.component.scss'],
    standalone: false
})
export class SelectComponent implements OnDestroy {
  selectedIds: number[] = [];
  results: any[] = [];

  subscription_get_externSelectedIdsQueryParams: Subscription;

  dropFeedbackMode: DragHighlight = 'push';
  itemOrientation: Orientation = 'vertical';
  dragDirection: DragDirection = 'both';
  scrollSpeed = 30;
  scrollSensitivity = 60;
  cursorOffset = null;

  constructor(
    private urlService: UrlService,
    private popupService: PopupService,
    private apiService: ApiService,
    private authService: AuthService,
    private storageService: StorageService,
    private configService: ConfigService
  ) {
    this.onInquireClick = this.onInquireClick.bind(this);
    this.onSearchClick = this.onSearchClick.bind(this);

    this.subscription_get_externSelectedIdsQueryParams = this.urlService.get_externSelectedIdsQueryParams.subscribe((ids) => {
      this.selectedIds = ids;

      if (ids !== null && ids !== undefined && ids.length > 0) {
        this.load();
      } else {
        this.results = [];
      }
    });
  }

  ngOnDestroy(): void {
    if (this.subscription_get_externSelectedIdsQueryParams) {
      this.subscription_get_externSelectedIdsQueryParams.unsubscribe();
    }
  }

  load() {
    this.apiService.post<any>(RouteKeys.Extern.get_selected, { ids: this.selectedIds }).subscribe({
      next: (response) => {
        let position: any = this.storageService.getFromLocale('position');
        this.results = [];

        for (let index = 0; index < this.selectedIds.length; index++) {
          const id = this.selectedIds[index];
          const dbKita = response.find((x) => x.id === id);

          let geoHelper = new Geohelper();
          let distance = position != null ? geoHelper.getDistanceBetweenTwoPoints(position.lat, position.lon, dbKita.lat, dbKita.lon) : 0;
          dbKita.distance = distance.toFixed(1);
          this.results.push(dbKita);
        }
      },
      error: (err) => {
        throw err;
      },
    });
  }

  onDeleteClick(item) {
    this.selectedIds.forEach((_item, _index) => {
      if (_item === item.id) {
        this.selectedIds.splice(_index, 1);
      }
    });

    this.urlService.refreshQueryParams({
      i: this.selectedIds.join(','),
    });
  }

  onDetailClick(item) {
    this.popupService.showDetailPopup(item);
  }

  onSearchClick() {
    if (this.authService.isLoggedIn()) {
      this.urlService.naviToPreserveQueryParams('intern/search');
    } else {
      this.urlService.naviToPreserveQueryParams('extern/search');
    }
  }

  onInquireClick() {
    this.urlService.naviToPreserveQueryParams('intern/inquire/care');
  }

  onDragStart(e) {
    e.itemData = this.results[e.fromIndex];
  }

  onReorder(e) {
    this.results.splice(e.fromIndex, 1);
    this.results.splice(e.toIndex, 0, e.itemData);

    this.reorderSelectedIds();
  }

  onReorderManual(index, upDown) {
    let source = this.results[index];
    let target = this.results[index + upDown];

    this.results.splice(index, 1, target);
    this.results.splice(index + upDown, 1, source);

    this.reorderSelectedIds();
  }

  reorderSelectedIds() {
    this.selectedIds = [];

    for (let i = 0; i < this.results.length; i++) {
      this.results[i].sortIndex = i;
      this.selectedIds.push(this.results[i].id);
    }

    // let _url = 'extern/select';
    // if (this.authService.isLoggedIn()) {
    //   _url = 'intern/select';
    // }

    // this.urlService.naviTo(_url, {
    //   i: this.selectedIds.join(','),
    // });

    this.urlService.refreshQueryParams({
      i: this.selectedIds.join(','),
    });
  }

  getButtonStyle() {
    if (window.document.documentElement.clientWidth <= 900) {
      return 'text';
    }
    return 'contained';
  }
}
